import { FC, ReactNode } from "react";
import { cx } from "shared/utils";
import { Loading02 } from "untitledui-js-base";

export const ProgressReportView: FC<{
  message?: string;
  children?: ReactNode;
  className?: string;
}> = ({ message, children, className }) => {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div
        className={cx(
          "flex max-w-md flex-col items-center justify-center gap-6 p-6",
          className
        )}
      >
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-warning-50">
          <Loading02 size="20px" className="stroke-warning-500" />
        </div>

        {children ? (
          <div>{children}</div>
        ) : (
          <p className="text-center text-sm font-medium text-content-300">
            {message || "Report in progress. Please wait"}
          </p>
        )}
      </div>
    </div>
  );
};
